import React from 'react';
import { useLocation } from 'react-router-dom';
import fascilitatorTrainingRoutes from './flow';
import ProgressBar from '../../../core/progress-bar/progress-bar';

const getCurrentSubrouteGroup = (pathname) => {
  for (const module of fascilitatorTrainingRoutes) {
    if (module.subRoutes && module.subRoutes.length > 1) {
      const currentIndex = module.subRoutes.findIndex(
        (subRoute) => subRoute.fullUrl === pathname,
      );

      if (currentIndex >= 0) {
        return {
          routes: module.subRoutes,
          currentIndex,
        };
      }
    }

    if (!module.sections) {
      continue;
    }

    for (const section of module.sections) {
      if (!section.subRoutes || section.subRoutes.length <= 1) {
        continue;
      }

      const currentIndex = section.subRoutes.findIndex(
        (subRoute) => subRoute.fullUrl === pathname,
      );

      if (currentIndex >= 0) {
        return {
          routes: section.subRoutes,
          currentIndex,
        };
      }
    }
  }

  return null;
};

const SubrouteProgress = () => {
  const location = useLocation();
  const currentGroup = getCurrentSubrouteGroup(location.pathname);

  if (!currentGroup) {
    return null;
  }

  return (
    <div className='w-full bg-white border-b border-slate-200 py-4 px-4'>
      <div className='mx-auto flex w-full max-w-4xl items-center justify-center overflow-x-auto'>
        <ProgressBar
          links={currentGroup.routes.map((route) => ({
            url: route.fullUrl,
            title: route.title,
          }))}
          completedLinks={currentGroup.routes
            .slice(0, currentGroup.currentIndex)
            .map((route) => route.fullUrl)}
        />
      </div>
    </div>
  );
};

export default SubrouteProgress;
